import { getWithURLParamImgPrev } from "../utils/httpClient-methods";
import tokenHttpClient from "../utils/httpClient";
import { API_URL,BASE_URL } from "../utils/AppApiUrl";

const SparePhotoPreview = async (baseURL, id, fileName, requestBody) => {
  try {
    const response = await getWithURLParamImgPrev(
      tokenHttpClient,
      `${BASE_URL}${API_URL.sparePhotosPrev}`,
      requestBody
    );

    if (response.status === 200) {   
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export default SparePhotoPreview;
